import React, { useContext, useEffect, useRef } from 'react';
import { IDishesContext, DishesContext } from '../../../dishesState/dishesContext';
import { IGetSubCategoriesShort, IGetSubCategoriesArguments } from 'types';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useFetchData } from 'hooks/useFetchData';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { getSubCategoriesShortInfoV2 } from 'backend/subcategories';
import Text from 'components/Text/Text';
import style from './SubcategorySelect.module.scss';

const { Option } = Select;

export const SubcategorySelect: React.FC = () => {
	const { setIDSubcategory, IDSelectedCategory, IDSelectedSubcategory } = useContext<IDishesContext>(DishesContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<
		IGetSubCategoriesShort,
		IGetSubCategoriesArguments
	>(IDSelectedCategory ? getSubCategoriesShortInfoV2 : null, {
		categoryId: IDSelectedCategory ? IDSelectedCategory : '',
	});
	const { t } = useTranslation('listing');

	useEffect(() => {
		refetch();
	}, [IDSelectedCategory]);

	const value = IDSelectedCategory && !loading ? IDSelectedSubcategory : undefined;

	return (
		<div className={style.container} data-test="SubcategorySelect">
			<Text translationNameSpace="listing" translationKey="subcategoryLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDSubcategory}
				value={value}
				loading={loading}
				disabled={!IDSelectedCategory || loading}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				listItemHeight={response?.data.subCategories.length}
				allowClear={true}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				{response?.data.subCategories.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							<Text
								translationNameSpace="listing"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Option>
						{response?.data.subCategories.map((el) => (
							<Option className={style.listItem} value={el.id} key={el.id}>
								{el.name}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};
